import { EntityContext } from './EntityContext';
export class AspectContext extends EntityContext {
    aspect_raw;
    constructor(aspect) {
        super(aspect);
        this.aspect_raw = aspect;
    }
    get aspect() {
        return this.aspect_raw;
    }
}
